import { render, staticRenderFns } from "./UnbindWechat.vue?vue&type=template&id=1e23de19"
import script from "./UnbindWechat.vue?vue&type=script&lang=js"
export * from "./UnbindWechat.vue?vue&type=script&lang=js"
import style0 from "./UnbindWechat.vue?vue&type=style&index=0&id=1e23de19&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports